import { ExternalLink } from 'lucide-react';

import { ButtonLink } from '../components/Button';
import { Container } from '../components/Container';
import { SectionHeading } from '../components/SectionHeading';
import { site } from '../content/shared';
import type { LandingContent } from '../content/types';

type TestimonialsSectionProps = {
  content: LandingContent;
};

export function TestimonialsSection({ content }: TestimonialsSectionProps) {
  return (
    <section className="section section--muted" aria-labelledby="testimonials-title">
      <Container>
        <SectionHeading id="testimonials-title" title={content.testimonials.h2} align="center" />
        <div className="testimonial-grid">
          {content.testimonials.items.map((item) => (
            <figure key={item.author} className="testimonial-card">
              <blockquote>“{item.quote}”</blockquote>
              <figcaption>
                <strong>{item.author}</strong>
                <span>{item.role}</span>
              </figcaption>
            </figure>
          ))}
        </div>
        <div className="section-cta">
          <ButtonLink
            variant="secondary"
            href={site.linkedinRecommendations}
            rel="noreferrer"
            target="_blank"
          >
            {content.testimonials.cta}
            <ExternalLink aria-hidden="true" size={16} />
          </ButtonLink>
        </div>
      </Container>
    </section>
  );
}
